import React from "react";
import exclamationIcon from "../../../assets/flash-message/exclamation.png";
import "./ErrorMessage.css";

const ErrorMessage = ({ message, onClose }) => {
  if (!message) return null;
  return (
    <div className="error-message-card">
      <div className="error-message-icon">
        <img src={exclamationIcon} alt="Error" />
      </div>
      <span className="error-message-text">{message}</span>
      <button
        className="error-message-close"
        onClick={onClose}
        aria-label="Close error"
        type="button"
      >
        ×
      </button>
    </div>
  );
};

export default ErrorMessage;
